import {createReducer} from "./index";
import * as R from 'ramda';
import {DO_CONVERT_BID} from "../actions/bids";

const conversionInitial = {
};

const conversionReducer = createReducer(conversionInitial,
  {
    // 'ACTION_NAME': function (state, action) -> new_state
    [DO_CONVERT_BID]: (state, action) => {
      const { bidId, projectId } = action.payload;
      return R.set(R.lensProp(bidId), projectId, state);
    },
  });

export default conversionReducer;



// WEBPACK FOOTER //
// ./src/reducers/conversion.js